import React,{useState} from "react";
import axiosInstance from "../../services/axios";
import { ActionTypes } from "../action-type";

export const getAllMember = (code,team_side)=> async (dispatch)=>{
    try{
        const avatars = await  axiosInstance.get(`/avatar/joined/avatar/${code}/${team_side}`);
        const {data} = avatars
        dispatch({
            type:ActionTypes.ALLMEMBER,
            payload:data
        })
    }
    catch (err){
        throw(err)
    }
}